import { LitElement, html, css, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js"
import { createRef, ref, Ref } from "lit/directives/ref.js";
import { WebComponentEvent } from "src/events/WebComponentEvent";
import { PageFeedback } from "src/components/feedback/page-feedback";
import { CloseViewEvent } from "src/events/close-view";
import "src/components/feedback/page-feedback";

export class DisplayFeedbackEvent extends WebComponentEvent {
  static readonly eventName = 'display-feedback-event';
  onDisconnect?: () => void;
  constructor(public reportKey?:number, public heading?:string, public placeholder?:string) {
    super(DisplayFeedbackEvent.eventName);
  }
}

@customElement("feedback-manager")
export class FeedbackManager extends LitElement {
  static styles = [
    css`
      :host {
        display: contents
      }
    `
  ];

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(DisplayFeedbackEvent.eventName, this.showFeedbackHandler);
  }
  
  @state() pageFeedback: { ref:Ref<PageFeedback>, reportKey?:number, heading?:string, placeholder?:string }[] = [];

  showFeedbackHandler = async (displayFeedbackEvent: DisplayFeedbackEvent) => {
    const feedbackRef: Ref<PageFeedback> = createRef();
    this.pageFeedback = [...this.pageFeedback, { ref:feedbackRef, reportKey:displayFeedbackEvent.reportKey, heading:displayFeedbackEvent.heading, placeholder:displayFeedbackEvent.placeholder }];
    await this.updateComplete;
    feedbackRef.value?.showModal();
  }

  removeFeedbackHandler  = (value:Ref<PageFeedback>) =>{
    return (e:CloseViewEvent) => { 
      this.pageFeedback = this.pageFeedback.filter(x=> x.ref !== value);
      e.stopPropagation();
      e.preventDefault();
    }
  }

  render() {
    return html`
      ${this.pageFeedback.map(x=> html`<page-feedback ${ref(x.ref)} .reportKey=${x.reportKey} .heading=${x.heading} .placeHolder=${x.placeholder}  @close-view=${this.removeFeedbackHandler}></page-feedback>`)}  
     `;
  }

  disconnectedCallback() {
    window.removeEventListener(DisplayFeedbackEvent.eventName, this.showFeedbackHandler);
    super.disconnectedCallback();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "feedback-manager": FeedbackManager;
  }
}
